import React, { useMemo } from 'react';
import { Save, X, Users } from 'lucide-react';
import DistrictMultiSelect from './DistrictMultiSelect';

function DriverSettingsDrawer({
  open,
  onClose,
  driverSettings,
  updateDriver,
  saveDriverPreferences,
  zones = [],
  districts = [],
}) {
  const drivers = useMemo(() => Object.values(driverSettings), [driverSettings]);
  const selectedCount = drivers.filter((driver) => driver.selected).length;

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[2000]">
      <button className="absolute inset-0 bg-slate-900/40" onClick={onClose} aria-label="Cerrar" />
      <aside className="absolute right-0 top-0 flex h-full w-full max-w-2xl flex-col bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-brand-primary" />
            <div>
              <h2 className="font-bold text-slate-900">Conductores disponibles</h2>
              <p className="text-xs text-slate-500">{selectedCount} seleccionados</p>
            </div>
          </div>
          <button onClick={onClose} className="rounded-lg border border-slate-200 p-2 text-slate-600">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="flex-1 space-y-3 overflow-y-auto p-4">
          {drivers.map((driver) => (
            <div key={driver.user_id} className="rounded-lg border border-slate-200 p-3">
              <div className="mb-3 flex items-center justify-between gap-2">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={driver.selected}
                    onChange={(event) => updateDriver(driver.user_id, { selected: event.target.checked })}
                  />
                  <span className="font-bold text-slate-900">{driver.name}</span>
                </label>
                <button
                  onClick={() => saveDriverPreferences(driver)}
                  className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2 py-1 text-xs font-bold text-slate-600"
                >
                  <Save className="h-3 w-3" />
                  Guardar
                </button>
              </div>

              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                <label className="text-xs font-semibold text-slate-600">
                  Max paquetes
                  <input
                    type="number"
                    min="1"
                    value={driver.max_packages}
                    onChange={(event) => updateDriver(driver.user_id, { max_packages: event.target.value })}
                    className="mt-1 w-full rounded-lg border border-slate-200 px-2 py-2 text-sm"
                  />
                </label>
                <label className="text-xs font-semibold text-slate-600">
                  Zona
                  <select
                    value={driver.route_zone}
                    onChange={(event) => updateDriver(driver.user_id, { route_zone: event.target.value })}
                    className="mt-1 w-full rounded-lg border border-slate-200 px-2 py-2 text-sm"
                  >
                    <option value="">Sin zona fija</option>
                    {zones.map((zone) => (
                      <option key={zone.id} value={zone.id}>
                        {zone.label}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="mt-3">
                <div className="mb-1 text-xs font-semibold text-slate-600">Distritos preferidos</div>
                <DistrictMultiSelect
                  districts={districts}
                  selected={driver.preferred_districts || []}
                  onChange={(preferred_districts) => updateDriver(driver.user_id, { preferred_districts })}
                />
              </div>
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
}

export default DriverSettingsDrawer;
